// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"40ec19a1","2":"a3ac9cca","277":"e83811b4"}[chunkId] + ".chunk.js";
};